import { ExpirationDateOption } from "./types";

export const EXPIRATION_DATE_OPTIONS: ExpirationDateOption[] = [
  {
    label: "No expiration date",
    id: "none",
  },
  {
    label: "30 Days",
    id: "day-30",
  },
  {
    label: "90 Days",
    id: "day-90",
  },
  {
    label: "6 Months",
    id: "month-6",
  },
  {
    label: "1 Year",
    id: "year-1",
  },
  {
    label: "Custom",
    id: "custom",
  },
];

export const MAX_ACCESS_TOKENS_COUNT = 10;
